import {Injectable} from '@angular/core';

@Injectable()
export class Funcoes {

  public isNumeric(value) {
      return /^\d+$/.test(value);
  }

  public findRegistro(dados, campo, index) {
      const result = dados.filter(function (data) {
          return data[campo] === index
      });
      return result[0];
  }

  public validaCPF(c) {
    if ((c = c.replace(/[^\d]/g, '')).length !== 11) {
      return false;
    }
    if (c === '00000000000') {
      return false;
    }
    let r;
    let s = 0;
    for (let i = 1; i <= 9; i++) {
      s = s + parseInt(c[i - 1], 10) * (11 - i);
    }
    r = (s * 10) % 11;
    if ((r === 10) || (r === 11)) {
      r = 0;
    }
    if (r !== parseInt(c[9], 10)) {
      return false;
    }
    s = 0;
    for (let i = 1; i <= 10; i++) {
      s = s + parseInt(c[i - 1], 10) * (12 - i);
    }
    r = (s * 10) % 11;
    if ((r === 10) || (r === 11)) {
      r = 0;
    }
    return !(r !== parseInt(c[10], 10));
  }

  public isEmpty(obj) {
    return Object.keys(obj).length === 0;
  }

}

